module.exports = __webpack_public_path__ + "static/media/epeen.b2017671.jpg";